import { useMemo } from 'react';
import type { IFormTheme } from '~/types';
import { generateColorShades, hexToHsl } from '~/utils/themeColors';

interface ThemeWrapperProps {
  theme?: IFormTheme;
  children: React.ReactNode;
}

export const ThemeWrapper = ({ theme, children }: ThemeWrapperProps) => {
  const style = useMemo(() => {
    if (!theme) return undefined;

    const vars: Record<string, string> = {};

    if (theme.primaryColor) {
      const shades = generateColorShades(theme.primaryColor);
      for (const [shade, color] of Object.entries(shades)) {
        vars[`--form-primary-${shade}`] = color;
      }

      // Set shadcn CSS variables so @rjsf/shadcn components pick up the theme color
      const [h, s, l] = hexToHsl(theme.primaryColor);
      const hslValue = `hsl(${h.toFixed(1)} ${s.toFixed(1)}% ${l.toFixed(1)}%)`;
      vars['--primary'] = hslValue;
      vars['--ring'] = hslValue;
    }

    if (theme.fontFamily) {
      vars['--form-font-family'] = theme.fontFamily;
    }

    if (theme.borderRadius) {
      vars['--form-border-radius'] = theme.borderRadius;
      vars['--radius'] = theme.borderRadius;
    }

    return Object.keys(vars).length > 0 ? vars : undefined;
  }, [theme]);

  if (!style) return <>{children}</>;

  return <div style={style}>{children}</div>;
};
